import { authdeviceV1 } from '../../requests/loader';
import { getEnableCMRExperience } from '../Utils';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import store from '../../store';
import { playFullMedia } from '../../actions/playmedia';
import { AAFPLAYER_STOP } from '../../AAFPlayer/constants';
import Device from '../../devices/device';
import Utils from '../Utils';

class UtilsCMRExperience {
    constructor() {
        this.isCMRExperienceInterval = null;
        this.intervalTime = null;
    
        this.setIntervalCMRExperience = this.setIntervalCMRExperience.bind(this);
    }

    //* Funcion para realizar el intervalo a la API queryUserSync
    setIntervalCMRExperience(history) {
        const { authdeviceCRM_interval } = getEnableCMRExperience();
        console.log('[authdeviceCRM_interval]:: ', authdeviceCRM_interval, history);
        const { timer_hour } = authdeviceCRM_interval;
        console.log('[timer_hour]:: ', timer_hour);
        // Se inhabilita el intervalo para los valores no aceptados en el setTimeout
        if (typeof timer_hour !== 'number' || isNaN(timer_hour) || timer_hour <= 0 || timer_hour > 596) {
            console.log(":::/[UtilsCMRExperience] - CRM Experience interval disabled", timer_hour);
            return;
        }
    
        if (!this.intervalTime) {
            this.intervalTime = timer_hour * 60 * 60 * 1000;
        }
    
        if (this.isCMRExperienceInterval) {
            clearInterval(this.isCMRExperienceInterval);
            this.isCMRExperienceInterval = null;
        }
    
        this.isCMRExperienceInterval = setInterval(async () => {
            try {
                const result = await authdeviceV1();
                if (result && result.data) {
                    console.log("[CRM Experience interval] - success", result.data);
                } else {
                    throw new Error(result);
                }
            } catch (err) {
                console.error("[CRM Experience interval] - failed", err);
                this.closeSession();
            }
        }, this.intervalTime);
    }

    closeSession() {
        // Get storage items
        let ui=DeviceStorage.getItem('__UUID__');
        const hadLoginSuccess = DeviceStorage.getItem('hadLoginSuccess');

        // Stop player
        const isPlaying = store.getState().player.playerstate === 'PLAYING';
        isPlaying && this.quitPlayer();
        DeviceStorage.clear();

        // Get information from Android
        const platform = Device.getDevice().getPlatform();
        const isAndroid = platform === 'android';
        try {
            if (isAndroid && window.AndroidPlayerInterface) {
                window.AndroidPlayerInterface.getUserInformation();
            }
        } catch (error) {
            console.log('[ERROR]-error on getUserInformation', error);
        }

        // Set storage items
        DeviceStorage.setItem('__UUID__', ui);
        DeviceStorage.setItem('IsLogOut', true);
        if (hadLoginSuccess === '1') DeviceStorage.setItem('hadLoginSuccess', '1');
        Utils.cleanCustomAttribute();

        // Restart application
        window.location.href='/';
    }

    quitPlayer() {
        const props = {
            ispip: false,
            islive: false,
            ispreview: false,
            playerstate: AAFPLAYER_STOP,
            event: null,
            videoid: null,
        }
        try {
            store.dispatch(playFullMedia(props));
        } catch (err) {
            console.error("Error in quitPlayer", err);
        }
    }
}

const instanceUtilsIsCMRExperience = new UtilsCMRExperience();

export default instanceUtilsIsCMRExperience;



// WEBPACK FOOTER //
// ./src/utils/userCMR/isCMRExperience.js